import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { OrganisationPledgesProvider as Provider } from '../../components/context/organisation-pledges.context';
import { sortBy } from 'lodash';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const ORGANISATION_PLEDGES_QUERY = graphql`
query NodeAllOrganisationPledgesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "OrganisationPledges" } }) {
    nodes {
      data
    }
  }
}
`;

export const OrganisationPledgesProvider: React.FC<any> = ({ children }) => {
  return (
    <Provider value={sortBy(shapeableProviderValue(useStaticQuery(ORGANISATION_PLEDGES_QUERY), 'items'), 'name')}>
      {children}
    </Provider>
  );
};
